import {parseUnifiedDiff} from '../../utils/parse-unified-diff'
import {DiffPreview} from './tool/DiffPreview'
import styles from './PermissionDiffPreview.module.css'

interface PermissionDiffPreviewProps {
  diff: string
  filePath?: string
}

function splitFilePath(filePath: string): {fileName: string; directory: string} {
  const lastSlash = filePath.lastIndexOf('/')
  if (lastSlash === -1) return {fileName: filePath, directory: ''}
  return {
    fileName: filePath.slice(lastSlash + 1),
    directory: filePath.slice(0, lastSlash),
  }
}

export function PermissionDiffPreview({diff, filePath}: PermissionDiffPreviewProps) {
  const diffLines = parseUnifiedDiff(diff)
  if (diffLines.length === 0) return null

  let additions = 0
  let deletions = 0
  for (const line of diffLines) {
    if (line.type === 'ADDITION') additions++
    else if (line.type === 'DELETION') deletions++
  }

  const {fileName, directory} = filePath ? splitFilePath(filePath) : {fileName: '', directory: ''}

  return (
    <div className={styles.Container}>
      {filePath && (
        <div className={styles.Header}>
          <span className={styles.fileName}>{fileName}</span>
          {directory && <span className={styles.directory}>{directory}</span>}
          <span className={styles.stats}>
            <span className={styles.additions}>+{additions}</span>{' '}
            <span className={styles.deletions}>-{deletions}</span>
          </span>
        </div>
      )}
      <DiffPreview diffLines={diffLines} canCollapse />
    </div>
  )
}
